<template>
  <div class="box">
    <label class="label">
      <b-tooltip
        label="Hidden menu items on web. eg. news to hide the News tab"
        dashed
        type="is-dark"
      >Hidden Menu Items</b-tooltip>
    </label>
    <div class="columns is-multiline">
      <div class="column is-one-third" :key="option" v-for="option in availableOptions">
        <label class="label">{{option}}</label>
        <b-switch
          type="is-danger"
          :value="hiddenTabs.indexOf(option) !== -1"
          @input="valueChanged(option)"
        ></b-switch>
      </div>
    </div>
    <label class="label">Other (comma,seperated)</label>
    <input class="input" type="text" v-model="otherValues" @input="handleOtherChanged">
  </div>
</template>

<script>
export default {
  name: "hidden-tabs-manager",
  props: ["hidden-tabs", "sport"],
  data() {
    const BASE = ["today", "news", "video", "results"];
    return {
      navs: {
        football: BASE.concat(["fixtures", "logs", "top-scorers"]),
        rugby: BASE.concat(["fixtures", "logs"]),
        cricket: BASE.concat(["fixtures", "logs"]),
        golf: BASE.concat(["schedule", "logs", "calendar"]),
        motorsport: BASE.concat(["schedule", "logs", "calendar"]),
        tennis: BASE.concat(["schedule", "rankings", "race", "calendar"])
      },
      otherValues: ""
    };
  },
  computed: {
    availableOptions() {
      return this.navs[this.sport];
    }
  },
  mounted() {
    this.otherValues = this.hiddenTabs
      .filter(x => !this.availableOptions.includes(x))
      .join(",");
  },
  methods: {
    valueChanged(option) {
      if (this.hiddenTabs.indexOf(option) === -1) {
        this.updateValue(this.hiddenTabs.concat([option]));
      } else {
        this.updateValue(this.hiddenTabs.filter(x => x != option));
      }
    },
    handleOtherChanged(e) {
      let data = this.hiddenTabs
        .filter(x => this.availableOptions.includes(x)) // keep known
        .concat(
          this.otherValues
            .split(",")
            .filter(x => !this.availableOptions.includes(x)) // stop from adding known
        )
        .filter((x, index, self) => self.indexOf(x) === index); // no dupes
      this.updateValue(data);
    },
    updateValue(newValue) {
      console.log(newValue);
      this.$emit("updated", newValue);
    }
  }
};
</script>
